module.exports = __webpack_public_path__ + "static/media/lens_rc.b5437ad9.png";